import { useState } from 'react';
import KakaoPostcodeEmbed, { Address } from 'react-daum-postcode';
import { useSearchParams } from 'react-router-dom';

import DeliveryAreaRefineResult from '~/components/delivery-area/refine/DeliveryAreaRefineResult';
import { DeliveryAreaRefineResultInfoArea } from '~/components/delivery-area/refine/DeliveryAreaRefineResultInfoArea';

const DeliveryAreaRefinePage = () => {
  const [searchParams] = useSearchParams();
  const vendor = searchParams.get('vendor');

  const [addressInfo, setAddressInfo] = useState<{ primaryAddress: string; zipCode: string }>();

  const handleComplete = (data: Address) => {
    let fullAddress = data.address;
    let extraAddress = '';

    // 검색된 기본 주소 타입 (R:도로명, J:지번)
    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    setAddressInfo({ primaryAddress: fullAddress, zipCode: data.zonecode });
  };

  if (!vendor) {
    return (
      <DeliveryAreaRefineResultInfoArea description="올바르지 않은 접근입니다. 정상적인 경로로 다시 조회해 주세요." />
    );
  }

  return addressInfo ? (
    <DeliveryAreaRefineResult
      primaryAddress={addressInfo.primaryAddress}
      zipCode={addressInfo.zipCode}
      onReset={() => setAddressInfo(undefined)}
      vendor={vendor}
    />
  ) : (
    <KakaoPostcodeEmbed onComplete={handleComplete} />
  );
};

export default DeliveryAreaRefinePage;
